import { IPassportGroupState } from '../interfaces/IPassportGroupState';
import { PassportGroupAction } from '../types/PassportGroupAction';
import { PassportGroupActionsEnum } from '../enums/PassportGroupActionsEnum';

const initial: IPassportGroupState = {
  passportGroupList: [],
  passportGroupListTotalCount: 0,
  passportGroupListCurrentPage: 0,
  passportGroupPassportList: [],
  passportGroupPassportListTotalCount: 0,
  passportGroupPassportListCurrentPage: 0,
  passportGroup: undefined,
  passportGroupInitForm: undefined,
  applySuccess: false,
  passportGroupCreateSuccess: false,
  notice: undefined,
  isExistsGroupsForCancellation: false,
  isDeleted: false,
};

export function passportGroupReducer(state = initial, action: PassportGroupAction) {
  switch (action.type) {
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_LIST: {
      return {
        ...state,
        passportGroupList: action.payload.data,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_TOTAL_COUNT: {
      return {
        ...state,
        passportGroupListTotalCount: action.payload.value,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_CURRENT_PAGE: {
      return {
        ...state,
        passportGroupListCurrentPage: action.payload.value,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_SET_LIST: {
      return {
        ...state,
        passportGroupPassportList: action.payload.data,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_SET_TOTAL_COUNT: {
      return {
        ...state,
        passportGroupPassportListTotalCount: action.payload.value,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_SET_CURRENT_PAGE: {
      return {
        ...state,
        passportGroupPassportListCurrentPage: action.payload.value,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET: {
      return {
        ...state,
        passportGroup: action.payload.data,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_APPLY_SUCCESS: {
      return {
        ...state,
        applySuccess: action.payload.value,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_CREATE_SUCCESS: {
      return {
        ...state,
        passportGroupCreateSuccess: action.payload.value,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_NOTICE: {
      return {
        ...state,
        notice: action.payload.value,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_INIT_FORM: {
      return {
        ...state,
        passportGroupInitForm: action.payload.data,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_IS_EXISTS_GROUPS_FOR_CANCELLATION: {
      return {
        ...state,
        isExistsGroupsForCancellation: action.payload.value,
      };
    }
    case PassportGroupActionsEnum.PASSPORT_GROUP_SET_IS_DELETED: {
      return {
        ...state,
        isDeleted: action.payload.value,
      };
    }
    default:
      return state;
  }
}
